import React from 'react';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import SocialWidget from '../Widget/SocialWidget';
import Newsletter from '../Widget/Newsletter';
import TextWidget from '../Widget/TextWidget';

export default function Footer() {
  return (
    <footer className="bg-cream pt-20 border-t border-[rgba(139,26,26,0.1)]">
      <div className="max-w-[1200px] mx-auto px-6 md:px-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8 pb-16">
          
          <div className="lg:col-span-4">
            <div className="mb-6">
              <img src="/logo.jpeg" alt="Noohra Logo" className="h-[50px] object-contain mb-4" />
              <p className="font-serif text-lg text-charcoal font-medium leading-snug">
                Noohra Integrated <br />& Allied Services Ltd.
              </p>
            </div>
            <ContactInfoWidget />
          </div>
          
          <div className="lg:col-span-3">
             {/* Reserved for links or other widgets */}
          </div>
          
          <div className="lg:col-span-5">
            <Newsletter
              title="Be Our Subscriber"
              subTitle="Get the latest news about mental health from our experts"
            />
          </div>
          
        </div>
      </div>
      
      <div className="bg-crimson py-6 text-white border-t border-crimson-dark">
        <div className="max-w-[1200px] mx-auto px-6 md:px-16 flex flex-col md:flex-row items-center justify-between gap-4">
          <SocialWidget white />
          <div className="text-[0.8rem] font-light tracking-wide m-0">
            Copyright © {new Date().getFullYear()} Noohra Services. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
